import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";
import MobileBottomTab from "./MobileBottomTab";
import GameIframe from "../game/GameIframe";
import SportsIframe from "../game/SportsIframe";
import AuthModal from "../auth/AuthModal";
import { useDeviceDetect } from "../../hooks/useDeviceDetect";
import { useSidebarStore } from "../../store/useSidebarStore";

const Layout = () => {
  const { isMobile } = useDeviceDetect();
  const { isCollapsed } = useSidebarStore();
  const location = useLocation();
  const isSportsRoute = location.pathname.startsWith("/sports/") || location.pathname.startsWith("/match/");

  // Compute classes matching old frontend exactly
  let mainAreaClass = "main-area";
  if (isMobile || isSportsRoute) {
    mainAreaClass += " mobile";
  } else {
    mainAreaClass += ` desktop ${isCollapsed ? "collapsed" : "expanded"}`;
  }

  return (
    <div className="app-container">
      <div className={mainAreaClass}>
        {/* Header (fixed, includes sidebar on desktop) */}
        <div className="header-main-container">
          <Header />
        </div>

        {/* Mobile sidebar (not in header) */}
        {isMobile && <Sidebar />}

        {/* Content */}
        <div className="content-container">
          <Outlet />
        </div>
      </div>

      {/* Bottom Navigation - mobile */}
      <MobileBottomTab />

      {/* Game iframe overlay (regular games - GameContext.js style) */}
      <GameIframe />

      {/* Sports iframe overlay (gameIframe.js style) */}
      <SportsIframe />

      {/* Auth modal */}
      <AuthModal />
    </div>
  );
};

export default Layout;
